import gql from 'graphql-tag';

export default gql`
  mutation revokeCredential($channelId: UUID!, $mapId: String!) {
    revokeCredential(channelId: $channelId, mapId: $mapId)
  }
`;
